import {api} from '../../utils/api'

export default {

    /**
     * load values
     * @param commit
     * @param id
     * @param all
     * @returns {*|Promise|Promise<any>}
     */
    loadValues({commit}, {id, showAll}) {
        return api.call(commit, 'get', '/api/tfvalue/' + id +"/"+(showAll ? 1 : 0), null, 'SET_VALUES');
    },

    /**
     * load linked
     * @param commit
     * @param id
     * @returns {*|Promise|Promise<any>}
     */
    loadLinkedValues({commit}, id) {
        return api.call(commit, 'get', '/api/tfvalue/linked/' + id, null, 'SET_VALUES');
    },

    /**
     * Save values
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    saveValues({commit}, {task_instance_id, values}) {
        return api.call(commit, 'post', '/api/tfvalue/instance/'+task_instance_id+'/save', {values: values}, 'SET_VALUES');
    },

    /**
     * Delete value
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    deleteValue({commit}, payload) {
        return api.call(commit, 'delete', '/api/values/' + payload.id, null, 'DELETE_VALUES');
    }
}
